import type { RouteLocationRaw } from 'vue-router';

export default defineNuxtRouteMiddleware((to) => {
  const partner = localStorage.getItem('partnerName');
  const sessionToken = localStorage.getItem('sessionToken');

  let redirect: RouteLocationRaw | undefined;

  if (!to.params.partner && partner) {
    redirect = {
      name: 'partner-home',
      params: { partner }
    };
  } else if (to.params.partner) {
    if (to.name === 'partner-sign-in' && sessionToken && to.params.partner === partner) {
      const lastVisited = to.query && to.query.redirect;
      // Redirect to home page or lastVisited
      if (lastVisited) {
        redirect = `${partner}/${lastVisited}`;
      } else {
        redirect = {
          name: 'partner-home',
          params: { partner }
        };
      }
    }
  }

  if (redirect) {
    return navigateTo(redirect);
  }
});
